/**
 * Typed tenant device management API facade over the generated contract client.
 */

import { tenantDevicesApi } from '../api/generated/tenantDevices.api.js';
import {
  type ClaimOrderRequest,
  type ClaimOrderResponse,
  type PendingShipmentsResponse,
  type TenantDeviceDetailResponse,
  type TenantDeviceListQuery,
  type TenantDeviceListResponse,
  type TenantDeviceRecord,
} from '@cnapse/shared/schemas.js';

class TenantDevicesService {
  async getTenantDevices(query?: TenantDeviceListQuery): Promise<TenantDeviceListResponse> {
    return tenantDevicesApi.list(query) as Promise<TenantDeviceListResponse>;
  }

  async getTenantUnclaimedDevices(): Promise<TenantDeviceRecord[]> {
    return tenantDevicesApi.listUnclaimed() as Promise<TenantDeviceRecord[]>;
  }

  async getPendingShipments(): Promise<PendingShipmentsResponse> {
    return tenantDevicesApi.getPendingShipments() as Promise<PendingShipmentsResponse>;
  }

  async getTenantDevice(serialNumber: string): Promise<TenantDeviceDetailResponse> {
    return tenantDevicesApi.getBySerial({ serialNumber }) as Promise<TenantDeviceDetailResponse>;
  }

  async patchTenantEfemPeripheral(
    serialNumber: string,
    efemPeripheral: Record<string, unknown> | null,
  ): Promise<{ success: boolean; data: { device: unknown } }> {
    return tenantDevicesApi.patchEfemPeripheral(
      { serialNumber },
      { efemPeripheral },
    ) as Promise<{ success: boolean; data: { device: unknown } }>;
  }

  async claimOrder(data: ClaimOrderRequest): Promise<ClaimOrderResponse> {
    return tenantDevicesApi.claimOrder(data) as Promise<ClaimOrderResponse>;
  }
}

export const tenantDevicesService = new TenantDevicesService();
